export function roundDecimals(number, decimals = 2) {
  const rate = 10 ** decimals;
  return number && Math.round(number * rate) / rate;
}

export function applyDiscount(coupon, value) {
  return (
    value &&
    roundDecimals(
      coupon.discountPercentage
        ? value * (1 - coupon.discountPercentage)
        : value - (coupon.discountValue || 0),
    )
  );
}



// WEBPACK FOOTER //
// ./src/site-render/src/lib/register.js